import styled from "styled-components";
import { GREEN_FADE_BG, GREEN_BORDER, TEXT_DARK } from "../../constants/theme";

export const AboutSection = styled.section`
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  background: ${GREEN_FADE_BG};
`;
export const Grid = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 42px 16px;
  display: grid;
  gap: 42px;
  align-items: center;
  grid-template-columns: 1fr;
  @media (min-width: 1024px) {
    grid-template-columns: 1.6fr 1fr;
  }
`;
export const H2 = styled.h2`
  color: ${TEXT_DARK};
  font-size: 1.875rem;
  font-weight: 700;
  @media (min-width: 768px) {
    font-size: 2rem;
  }
`;
export const Body = styled.p`
  margin-top: 16px;
  color: #334155;
  line-height: 1.7;
`;
export const InfoCard = styled.div`
  border: 1px solid ${GREEN_BORDER};
  border-radius: 12px;
  padding: 24px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  margin-top: 72px;
`;
export const Bullet = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #0f172a;
  font-size: 0.95rem;
  &::before {
    content: "";
    display: inline-block;
    margin-top: 6px;
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: #24ae7c;
  }
  &:not(:first-child) {
    margin-top: 10px;
  }
`;
